import React from "react";
import { Dialog, DialogContent, Typography, Button } from "@mui/material";
import { makeStyles } from "tss-react/mui";

function SignoutModal({ open, setOpen, onConfirm }) {
  const { classes } = useStyles();

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog onClose={handleClose} aria-labelledby="signout-modal" open={open}>
      <DialogContent className={classes.dialogRoot}>
        <Typography className={classes.title} variant="body1">
          Sign-out from Spinny refurb dashboard?
        </Typography>
        <Button color="primary" variant="contained" fullWidth onClick={onConfirm} className={classes.button}>
          Sign out
        </Button>
        <Button color="primary" variant="outlined" fullWidth onClick={handleClose} className={classes.button}>
          Cancel
        </Button>
      </DialogContent>
    </Dialog>
  );
}

const useStyles = makeStyles()((theme) => ({
  dialogRoot: {
    width: 300,
  },
  title: {
    textAlign: "center",
    maxWidth: 200,
    margin: "auto",
    marginBottom: 16,
  },
  button: {
    marginBottom: 12,
    height: 52,
    boxShadow: "none",
    textTransform: "none",
  },
}));

export default SignoutModal;
